export function hasPermission(permission, permissions) {
    return permissions.includes("*") || permissions.includes(permission);
}
//# sourceMappingURL=hasPermission.js.map